export const activityLog = {
  activityLogs: "Activity Logs",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  status: "Status",
  selectStatus: "SELECT STATUS",
  all: "ALL",
  pending: "PENDING",
  approved: "APPROVED",
  rejected: "REJECTED",
  userId: "User ID",
  username: "Username",
  action: "ACTION",
  updatedField: "Updated Field",
  originalValue: "Original Value",
  updatedValue: "Updated Value",
  notes: "Notes",
  cancel: "Cancel",
  filter: "Filter",
  actionBy: "ACTION BY",
  approvedBy: "APPROVED BY",
  updatedDate: "UPDATED DATE",
  status: "STATUS",
  amount: "AMOUNT",
  createdAt: "CREATED DATE",
  traceId: "TRACE ID",
  ipAddress: "IP ADDRESS",
  actionTo: "ACTION TO",
  logId: "LOG ID",
  viewDetail: "View Detail",
  originalValue: "Original Value",
  updatedValue: "Updated Value",
  copySuccess: "คัดลอกสำเร็จ",
  copyFail: "คัดลอกไม่สำเร็จ"
};
